<div role="main" class="app-page" [class.touch-device]="touchDevice">
  <div class="app-content">
    <router-outlet></router-outlet>
  </div>
</div>
